import { CUSTOM_TYPES_LIST } from "@/domains/profile/constants/custom-types";
import { FIELD_SIZE_MD } from "@/domains/profile/constants/field-sizes";
import { FieldVariant, formatFieldVariant } from "@/domains/profile/models/ProfileFieldVariant";
import { formatProfileFieldModel } from "@/domains/profile/models/ProfileFieldModel";

const [defaultFieldType] = CUSTOM_TYPES_LIST;

export function CustomFormModel() {
    const form = {
        name: "",
        fieldType: defaultFieldType,
        required: false,
        mobile: true,
        available: true,
        contract: true,

        size: { value: FIELD_SIZE_MD },

        // file
        limitFiles: false,
        maxFiles: "",

        // text
        limitText: false,
        minLength: "",
        maxLength: "",
        multiline: false,

        // lists
        custom: false,
        saveCustom: false,

        variants: [],
    };

    const setVariants = (list) => {
        form.variants = list.map(FieldVariant);
    };

    const setData = (field) => {
        const { fieldType, size, ...fieldParams } = field;

        form.fieldType = { value: fieldType };
        form.size = { value: size };

        Object.keys(fieldParams).forEach((key) => {
            form[key] = fieldParams[key];
        });

        form.multiline = field.multiline;
    };

    const resetAdditionalValues = () => {
        form.limitFiles = false;
        form.maxFiles = "";
        form.multiline = false;
        form.limitText = false;
        form.maxLength = "";
        form.minLength = "";
        form.custom = false;
        form.saveCustom = false;
        form.variants = [];
    };

    const getParams = () => {
        const { fieldType, required, size, ...otherParams } = form;

        const fieldParams = {
            fieldType: fieldType.value,
            size: size.value,
            required,
            ...otherParams,
        };
        return formatProfileFieldModel(fieldParams);
    };

    const getDictionary = () => {
        const filteredVariants = form.variants
            .map((v) => ({
                ...v,
                text: v.text.trim(),
            }))
            .filter((v) => !!v.text);
        return filteredVariants.map(formatFieldVariant);
    };

    const reset = () => {
        form.fieldType = defaultFieldType;
        form.size = { value: FIELD_SIZE_MD };

        form.mobile = true;
        form.available = true;
        form.contract = true;
        resetAdditionalValues();
    };

    return {
        data: form,
        setVariants,
        setData,
        resetAdditionalValues,
        getParams,
        getDictionary,
        reset,
    };
}
